import store_patient from "@/store/mods/clinique/patients"

export default {
    name: 'choix-patient',
    components: {},
    props: [],
    data() {
        return {
            list_patients: [],
            patient_is_loading: true,
            patient_is_empty: false,
            is_load_error: false,

            patient_filter: "",
            perPage: -1,
            currentPage: 1,
            total_pages: 0,
            fields: [
                { key: 'patient', label: 'Patients' }, { key: 'sexe', label: 'Sexes' }, { key: 'age', label: 'Âge' },
                { key: 'telephone', label: 'Téléphones' }, 'assurance', 'action.s'
            ],
            search_filter: {
                with_consultation: false
            }
        }
    },

    watch: {
        patient_filter() {
            if (this.patient_filter == '') {
                this.search_filter.search_term = ''
                this.getListePatients()
            }
        }  
    },

    computed: {
    },

    mounted() {
        this.getListePatients()
    },

    methods: {
        getListePatients() {
            this.is_load_error = false
            this.patient_is_loading = true
            store_patient.getListeAllPatient(this.search_filter).then((patients) => {
                this.list_patients = patients.data
                this.total_pages = patients.last_page
                if (this.list_patients.length > 0) {
                    this.patient_is_empty = false
                } else {
                    this.patient_is_empty = true
                }
    
                this.patient_is_loading = false
            }).catch(() => {
                this.is_load_error = true
                this.patient_is_loading = false
            })
        },

        setSelectedPatient(patient_data) {
            const selected_patient = {
                patient_id: parseInt(patient_data.patient_id),
                nom: patient_data.patient_nom,
                prenoms: "",
                nom_patient: patient_data.patient_nom,
                sexe: patient_data.sexe,
                telephone_mobile: patient_data.patient_telephone,
                age: patient_data.age,
                num_dossier: patient_data.patient_code
            }
            this.$emit('emitSelectedPatient', selected_patient)
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.search_filter.page = this.currentPage
                this.getListePatients()
            }
        },

        nextPage() {
            if (this.currentPage < this.total_pages) {
                this.currentPage++;
                this.search_filter.page = this.currentPage
                this.getListePatients()
            }
        },

        gotoPage(page) {
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.search_filter.page = this.currentPage
                this.getListePatients()
            }
        },

        searchPatient() {
            this.search_filter.search_term = this.patient_filter
            this.getListePatients()
        }
    }
}